import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModuleListModel } from 'app/module/models/module-list.model';
import { QuestionService } from 'app/question/services/question.service';

@Component({
    selector: 'app-add-question-bank',
    templateUrl: './add-question-bank.component.html',
    styleUrls: ['./add-question-bank.component.css']
})
export class AddQuestionBankComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    modules: ModuleListModel[];
    submitAttempt: boolean = false;
    addQuestionBankFormGroup: FormGroup;

    constructor(
        private questionService: QuestionService,
        private fb: FormBuilder,
		private location: Location,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Question Bank', breadcrumbs: [
                { title: 'Question Banks', url: ['/question/questionbank'] }
            ]
        }
        this.initializeForm();
    }

    initializeForm(): void {
        this.addQuestionBankFormGroup = this.fb.group(
            {
                name: ['', Validators.required],
                nrOptionalQuestions: ['', Validators.required]
            }
        );
    }

    addModule(): void {
        this.submitAttempt = true;
        if (this.addQuestionBankFormGroup.valid) {
            const formValue = this.addQuestionBankFormGroup.value;
            this.questionService.createQuestionBank(formValue).subscribe(
                questionBankId => {
                    this.router.navigate(['./question/questionbank']);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }
}
